import { useQuery } from '@tanstack/react-query';
import { getRouteApi } from '@tanstack/react-router';
import { pcmpRedisburseBatchReportQueryOptions } from '../api/pcmpAccounts.api';
import { PcmpBatchPrintView } from '../components/PcmpBatchReport/PcmpBatchPrintView';
import { PCMP_REDISBURSE_VIEW_LABELS } from '../constants/pcmpAccounts.constants';

const route = getRouteApi('/_print/pcmp/accounts/redisburse-batches/$batchNo/print');

export function PcmpRedisburseBatchPrintPage() {
  const { batchNo } = route.useParams();
  const { view } = route.useSearch();
  const { data, isLoading, isFetching, error, refetch } = useQuery({
    ...pcmpRedisburseBatchReportQueryOptions(batchNo, view),
    // Closing the print dialog refocuses the tab; keep the sheet as printed.
    refetchOnWindowFocus: false,
  });

  return (
    <PcmpBatchPrintView
      batchNo={batchNo}
      report={data}
      isLoading={isLoading}
      isFetching={isFetching}
      error={error}
      refetch={() => void refetch()}
      documentTitle={`CMP Accounts Re-Disbursement Batch ${batchNo} (${PCMP_REDISBURSE_VIEW_LABELS[view]})`}
    />
  );
}
